import TAG from "@constants/Tag";

import { useLocalizedCartInfo } from "./useLocalizedCartInfo";
import useRecommendation from "./useRecommendation";

/**
 * Returns up to 3 recommended upsell products for the side cart,
 * filtered to exclude:
 *  1. products already in the cart,
 *  2. out-of-stock items,
 *  3. products with more than 8 variants, and
 *  4. MTO products.
 *
 * Recommendations are driven by the most recently added product (that is not AL LUXE product)
 * in the cart via `useRecommendation`.
 */
export default function useUpSellProducts(returnFullData, numberOfProducts = 3) {
  const cartInfo = useLocalizedCartInfo();
  const handlesToExclude = new Set();
  const arrUpsellProducts = [];
  cartInfo.lines.forEach((line) => {
    handlesToExclude.add(line.variant.product.handle);
  });

  const latestProductIdAdded =
    cartInfo.lines.filter((c) => c?.variant.sku !== "L-0001")[0]?.variant.product.id || null;

  const [, recommendedProducts, recommendationId] = useRecommendation(
    "Side Cart",
    arrUpsellProducts,
    (product) =>
      !product ||
      (!handlesToExclude.has(product.shopify.handle) &&
        product.shopify.variants.some((variant) => variant.availableForSale) &&
        product.shopify.variants.length <= 8 &&
        !product.shopify.tags?.includes(TAG.MTO)),
    latestProductIdAdded
  );

  const recommendedData = recommendedProducts
    .filter((product) => product)
    .slice(0, numberOfProducts)
    .map((p) =>
      returnFullData ? p : { ...p.shopify, title: p.contentful.title, contentful: p.contentful }
    );

  return {
    data: recommendedData,
    isLoading: recommendedProducts.some((product) => product === undefined),
    id: recommendationId,
  };
}
